export const changePasswordModalName = 'change-password';
